<template>
  <div class="logout">
    <v-card flat>
      <v-card-text class="text-center">
        <div class="body-1 mb-3">
          ログアウト中
        </div>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang="scss">
.logout {

}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data: () => ({

  }),
  async mounted() {
    await new Promise(resolve => setTimeout(resolve, 500));
    await firebase.auth().signOut()
      .then(() => {
        this.$store.dispatch('resetUserData');
        this.$router.push({ name: 'home' });
      })
      .catch(err => {
        console.error(err);
      });
  }
};
</script>
